import { isValidPhoneNumber } from 'libphonenumber-js';

// Canonical (XXX) XXX-XXXX shape — the single source of truth for the format check.
// Duplicated verbatim from Consumers.UI (core/utils/phone.ts) to keep both apps consistent.
export const PHONE_FORMAT_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;

// True when `value` is both correctly formatted and a real, dialable US number.
// Callers treat empty as valid (required() owns emptiness); returns false for empty.
export function isValidUsPhone(value: string): boolean {
  return PHONE_FORMAT_REGEX.test(value) && isValidPhoneNumber(value, 'US');
}

// Passed to yt-form-control's [formErrors] so it renders a message for the `phone` validation
// error kind. The value is an ngx-translate key resolved by the control's `| translate`.
export const PHONE_FORM_ERRORS = { phone: 'Common.Invalid_Phone_Number' };
